import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { DateRangeTimeValue } from '../../entity/conditionvalue/daterangetimevalue';

export class DateRangeTimeHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const arr = [];
        const drv = (qc.value as DateRangeTimeValue);
        if(Object.keys(drv).length === 0 || (!drv.startTime && !drv.endTime))
            return arr;
        drv.startTime && arr.push({
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.GreaterThanOrEqual, //GreaterOrEqual
            'Value' : drv.startTime,
            'Relation' : RelationType.And, //and
            'Expresstype': ValueType.Value
        });
        drv.endTime && arr.push({
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.LessThanOrEqual, //LessOrEqual
            'Value' : drv.endTime,
            'Relation' : RelationType.And,//and
            'Expresstype': ValueType.Value
        });

        return arr;
    }
}